import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'core-js/actual/promise/finally';
import { createBaseGainsightProvider } from '@rsos/capstone';
import '@rsos/capstone/src/overridePublicPath';
import ErrorBoundary from '@rsos/components/capstone/ErrorBoundary';
import Layout from '@rsos/components/capstone/Layout';
import { gspx } from '@rsos/gainsight';
import {
  getAmplitudeApiKey,
  getAmplitudeProxyOrigin,
} from '@rsos/utils/metaTags';
import { initDatadogFlags, OpenFeatureProvider } from '@rsos/utils/openFeature';
import { captureExceptionWithScope } from '@rsos/utils/sentry';
import Main from './app/Main';
import { store } from './app/store';
import './styles/global.scss';

// Every admin section this app owns. Drives sidebar active-state in Layout.
const APP_PATHS = [
  '/admin/text-from-911',
  '/admin/messaging',
  '/admin/settings',
  '/admin/notifications',
  '/admin/data-source',
  '/admin/keywords',
  '/admin/alerts-routing',
  '/admin/responders',
  '/admin/share-and-chat',
  '/admin/peer-agencies',
  '/admin/landing-zones',
  '/admin/access',
  '/admin/integrations',
  '/admin/psap',
];

const dataProvider = {
  ...createBaseGainsightProvider(store),
  // The admin app doesn't handle call data.
  getSelectedCallData: () => null,
};
gspx.initialize(dataProvider, {
  captureError: captureExceptionWithScope,
  amplitude: {
    apiKey: getAmplitudeApiKey(),
    proxyOrigin: getAmplitudeProxyOrigin(),
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root was not found');
}
const root = createRoot(container);

// Register the Datadog OpenFeature provider so the flag hooks and getFlag resolve here.
initDatadogFlags();

root.render(
  <OpenFeatureProvider>
    <Provider store={store}>
      <BrowserRouter>
        <Layout appPaths={APP_PATHS}>
          <ErrorBoundary>
            <Main />
          </ErrorBoundary>
        </Layout>
      </BrowserRouter>
    </Provider>
  </OpenFeatureProvider>,
);
